import request from '@/utils/request';

/**
 * 获取消息列表
 */
export function getMessages(params) {
  return request({
    url: '/message/list',
    method: 'get',
    params,
  });
}

/**
 * 获取消息统计
 */
export function getMessageStats() {
  return request({
    url: '/message/stats',
    method: 'get',
  });
}

/**
 * 标记消息为已读
 */
export function markAsRead(messageId) {
  return request({
    url: `/message/${messageId}/read`,
    method: 'post',
  });
}

/**
 * 批量标记已读
 */
export function batchMarkAsRead(messageIds) {
  return request({
    url: '/message/batch-read',
    method: 'post',
    data: {
      message_ids: messageIds,
    },
  });
}

/**
 * 全部标记为已读
 */
export function markAllAsRead() {
  return request({
    url: '/message/read-all',
    method: 'post',
  });
}

/**
 * 删除消息
 */
export function deleteMessage(messageId) {
  return request({
    url: `/message/${messageId}`,
    method: 'delete',
  });
}

/**
 * 创建消息（管理员）
 */
export function createMessage(data) {
  return request({
    url: '/message/create',
    method: 'post',
    data,
  });
}
